var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tree',{staticClass:"t-tree",attrs:{"data":_vm.treeList,"showCheckbox":""},on:{"on-check-change":_vm.onCheckHouse}})
}
var staticRenderFns = []

export { render, staticRenderFns }